import React, { useState, useEffect } from "react";
import { ItemMenu } from "../../components/Service";
import Service from "../../models/Service";
import { loadServiceItems } from "../../utils/helper-function"

const Games: React.FC = () => {
  const [games, setGames] = useState<Service[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

    useEffect(() => {
      const loadGames = async () => {
        const [games, categories] = await loadServiceItems("games");
        setGames(games);
        setCategories(categories);
      };
      loadGames();
    }, []);
  return (
    <ItemMenu 
      title="Games" 
      items={games} 
      categories={categories} 
    />
  );
};

export default Games;